import {
    CREATE_ADDITIONAL_EXPENSE_FAILURE,
    CREATE_ADDITIONAL_EXPENSE_REQUEST,
    CREATE_ADDITIONAL_EXPENSE_SUCCESS,
    CREATE_USER_FORM_ADDITIONAL_EXPENSE,
    DELETE_ADDITIONAL_EXPENSE_FAILURE,
    DELETE_ADDITIONAL_EXPENSE_REQUEST,
    DELETE_ADDITIONAL_EXPENSE_SUCCESS,
    FETCH_SINGLE_ADDITIONAL_EXPENSE_FAILURE,
    FETCH_SINGLE_ADDITIONAL_EXPENSE_REQUEST,
    FETCH_SINGLE_ADDITIONAL_EXPENSE_SUCCESS,
    FETCH_ADDITIONAL_EXPENSE_FAILURE,
    FETCH_ADDITIONAL_EXPENSE_REQUEST,
    FETCH_ADDITIONAL_EXPENSE_SUCCESS,
    ADDITIONAL_EXPENSE_USERFORM_RESET,
    UPDATE_ADDITIONAL_EXPENSE_FAILURE,
    UPDATE_ADDITIONAL_EXPENSE_REQUEST,
    UPDATE_ADDITIONAL_EXPENSE_SUCCESS
} from './pimAdditionalExpense.actionsType';

export const PIM_ADDITIONAL_EXPENSE = 'pimAdditionalExpense';

let initialState = {
    loading: false,
    teamDetailsById: [],
    userform: {},
    selectedTeamDetails: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let pimAdditionalExpenseReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_ADDITIONAL_EXPENSE_REQUEST:
        case CREATE_ADDITIONAL_EXPENSE_REQUEST:
        case FETCH_SINGLE_ADDITIONAL_EXPENSE_REQUEST:
        case UPDATE_ADDITIONAL_EXPENSE_REQUEST:
        case DELETE_ADDITIONAL_EXPENSE_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_ADDITIONAL_EXPENSE_SUCCESS:
            return {
                ...state,
                loading: false,
                teamDetailsById: updatePayload
            };
        case CREATE_ADDITIONAL_EXPENSE_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {}
            };
        case FETCH_SINGLE_ADDITIONAL_EXPENSE_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedTeamDetails: updatePayload,
                userform: updatePayload
            };
        case UPDATE_ADDITIONAL_EXPENSE_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedTeamDetails: {},
                userform: {}
            };
        case DELETE_ADDITIONAL_EXPENSE_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                selectedTeamDetails: {}
            };
        case FETCH_ADDITIONAL_EXPENSE_FAILURE:
        case FETCH_SINGLE_ADDITIONAL_EXPENSE_FAILURE:
        case CREATE_ADDITIONAL_EXPENSE_FAILURE:
        case UPDATE_ADDITIONAL_EXPENSE_FAILURE:
        case DELETE_ADDITIONAL_EXPENSE_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_ADDITIONAL_EXPENSE:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case ADDITIONAL_EXPENSE_USERFORM_RESET:
            return {
                ...state,
                userform: {},
                selectedTeamDetails: {}
            };
        default:
            return state;
    }
};
